<template>
  <div :class="success ?  'CreateAgentArtifact' : 'CreateAgentArtifact__error' ">
    <div class="CreateAgentArtifact__header">
      <span>{{ outputObject.title }}</span>
      <v-btn icon @click="loadArtifact()" :loading="loading"><v-icon> {{ 'mdi-open-in-new' }} </v-icon></v-btn>
    </div>
    <div v-if="!success">
      <div class="CreateAgentArtifact__error_body">
        <span style="font-weight: bold;">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

const {
  mapActions: AIChatActions,
  mapMutations: AIChatMutations,
} = createNamespacedHelpers("AIChat");

import Vue from "vue";
import { createNamespacedHelpers } from 'vuex';

Vue.use(VueLoaders);

export default {
  name: 'create-agent-artifact-output',
  components: { },
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    outputObject() {
      return typeof this.output !== 'string' ? this.output : JSON.parse(this.output)
    },
    isValidJson() {
      try {
        if(typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {
    ...AIChatActions(['getAgentArtifact']),
    ...AIChatMutations({
      setArtifact: "SET_CHAT_ARTIFACT",
    }),
    async loadArtifact() {
      this.loading = true;
      const artifact = await this.getAgentArtifact({
        artifactId: this.outputObject.id,
      })
      this.setArtifact(artifact);
      this.loading = false;
    }
  },
};
</script>

<style scoped lang="scss">
@import './index';
</style>
